// extracted by mini-css-extract-plugin
export var bubble = "_42-0";
export var container = "_42-3";
export var contrastBorder = "_42-4";
export var greyOut = "_42-2";
export var initialsWrapper = "_42-1";
export var large = "_42-9";
export var medium = "_42-8";
export var mediumSmall = "_42-7";
export var mediumSmallMedium = "_42-c";
export var micro = "_42-5";
export var small = "_42-6";
export var tiny = "_42-b";
export var xTiny = "_42-a";